module.exports = __webpack_public_path__ + "images/videoCaseStudy-nivea-results-photo-01.jpg?h=2e4e007ac7ade61af0cb01830c93d641";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-results-photo-01.jpg
// module id = 2115
// module chunks = 12 15